import React from "react";
import {
    CModal,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CButton,
} from '@coreui/react';

const MsgPopup = ({flag,setFlag, message, modalType}) => {
    return(
        <div>
            <CModal
                visible={flag}
                onClose={() => {setFlag(false)}}
            >
                <CModalHeader
                    onClose={() => {setFlag(false)}}
                >
                    <CModalTitle id="LiveDemoExampleLabel">Alert</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <div>
                        <h5 className={`text-${modalType === 'error' ? 'red' : 'blue'}-500`} >{message}</h5>
                    </div>
                </CModalBody>
                <CModalFooter>
                    <CButton
                        color="primary"
                        onClick={() => {setFlag(false)}}
                    >
                        Ok
                    </CButton>
                </CModalFooter>
            </CModal>
        </div>
    )
}

export default MsgPopup